import { ActionTree } from "vuex";
import { ServiceProfileState, ServiceProfile } from "./model";
import { RootStateType } from "@/store";
import { AxiosResponse } from "axios";

const actions: ActionTree<ServiceProfileState, RootStateType> = {
  findList({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].get('/service_profiles', { params: params })
      .then((response: AxiosResponse) => {
        const serviceProfiles: ServiceProfile[] = response.data;
        commit('setServiceProfiles', serviceProfiles)
        return serviceProfiles
      })
  },
  get({ rootGetters, commit }, params) {
    const id = params.id;
    delete params.id;
    return rootGetters['hcs/client'].get(`/service_profiles/${id}`, { params: params })
        .then((response: AxiosResponse) => {
          return response.data as ServiceProfile
        })
  },
  create({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].post('/service_profiles', params)
        .then((response: AxiosResponse) => {
          const serviceProfile: ServiceProfile = response.data;
          commit('addServiceProfile', serviceProfile);
          return serviceProfile;
        });
  },
  update({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].patch(`/service_profiles/${params.id}`, params)
        .then((response: AxiosResponse) => {
          const serviceProfile: ServiceProfile = response.data;
          commit('updateServiceProfile', serviceProfile);
          return serviceProfile;
        });
  },
  delete({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].delete(`/service_profiles/${id}`)
        .then((response: AxiosResponse) => {
          commit('deleteServiceProfile', id);
        });
  }
}

export default actions;
